import React from 'react';

const ForPublishers = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      width={49}
      height={53}
      viewBox='0 0 49 53'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M23.1284 53H2.76566e-05L2.7658e-05 0L23.1284 0L23.1284 53Z'
        fill='#FF5612'
      />
      <path
        d='M21.928 10.2498H1.20022L1.20022 1.14062H21.928L21.928 10.2498Z'
        fill='white'
      />
      <path
        d='M21.928 20.6014H1.20022L1.20022 11.4922H21.928L21.928 20.6014Z'
        fill='white'
      />
      <path
        d='M21.8479 30.9685H1.12014L1.12014 21.8594H21.8479L21.8479 30.9685Z'
        fill='white'
      />
      <path
        d='M21.928 41.3045H1.20022L1.20022 32.1953H21.928L21.928 41.3045Z'
        fill='white'
      />
      <path
        d='M21.928 51.656H1.20022L1.20022 42.5469H21.928L21.928 51.656Z'
        fill='white'
      />
      <path
        d='M12.5006 20.5213L12.4095 12.8672L10.1646 12.9469L10.1771 20.5213H12.5006Z'
        fill='#FF5612'
      />
      <path
        d='M12.04 13.6562H10.5137L10.5137 14.1489H12.0599L12.04 13.6562Z'
        fill='white'
      />
      <path
        d='M12.04 14.2969H10.5137L10.5137 14.7895H12.0599L12.04 14.2969Z'
        fill='white'
      />
      <path
        d='M12.04 14.9375H10.5137L10.5137 15.4301H12.0599L12.04 14.9375Z'
        fill='white'
      />
      <path
        d='M19.7684 19.5437L16.4886 12.3203L14.4488 13.2465L17.542 20.5546L19.7684 19.5437Z'
        fill='#FFCCA8'
      />
      <path
        d='M16.4215 12.9531L14.8814 13.6524L16.01 16.3861L17.6435 15.6444L16.4215 12.9531Z'
        fill='#FF5612'
      />
      <path
        d='M14.5397 20.5148L14.7209 13.5H12.4097L12.5008 20.5148H14.5397Z'
        fill='#FCE99A'
      />
      <path
        d='M14.3004 17.9297H12.8653L12.8653 20.0311H14.3004L14.3004 17.9297Z'
        fill='#FFF8D2'
      />
      <path
        d='M15.8611 4.26562H11.4844L11.4844 7.2591H15.8611L15.8611 4.26562Z'
        fill='#FCE99A'
      />
      <path
        d='M15.4326 4.64844H11.9131L11.9131 6.87457H15.4326L15.4326 4.64844Z'
        fill='#FFF8D2'
      />
      <path
        d='M14.984 5.33829H12.3615C12.3372 5.33829 12.3174 5.31854 12.3174 5.29415C12.3174 5.26975 12.3372 5.25 12.3615 5.25H14.984C15.0083 5.25 15.0282 5.26975 15.0282 5.29415C15.0282 5.31854 15.0083 5.33829 14.984 5.33829Z'
        fill='white'
      />
      <path
        d='M14.984 5.80702H12.3615C12.3372 5.80702 12.3174 5.78729 12.3174 5.7629C12.3174 5.7385 12.3372 5.71875 12.3615 5.71875H14.984C15.0083 5.71875 15.0282 5.7385 15.0282 5.7629C15.0282 5.78729 15.0083 5.80702 14.984 5.80702Z'
        fill='white'
      />
      <path
        d='M14.984 6.27576H12.3615C12.3372 6.27576 12.3174 6.25603 12.3174 6.23163C12.3174 6.20723 12.3372 6.1875 12.3615 6.1875H14.984C15.0083 6.1875 15.0282 6.20723 15.0282 6.23163C15.0282 6.25603 15.0083 6.27576 14.984 6.27576Z'
        fill='white'
      />
      <path
        d='M15.8611 7.25781H11.4844L11.4844 10.2513H15.8611L15.8611 7.25781Z'
        fill='#FF5612'
      />
      <path
        d='M15.4326 7.64062H11.9131L11.9131 9.86674H15.4326L15.4326 7.64062Z'
        fill='#FFCCA8'
      />
      <path
        d='M14.984 8.33044H12.3615C12.3372 8.33044 12.3174 8.31071 12.3174 8.28632C12.3174 8.26192 12.3372 8.24219 12.3615 8.24219H14.984C15.0083 8.24219 15.0282 8.26192 15.0282 8.28632C15.0282 8.31071 15.0083 8.33044 14.984 8.33044Z'
        fill='white'
      />
      <path
        d='M14.984 8.79138H12.3615C12.3372 8.79138 12.3174 8.77163 12.3174 8.74725C12.3174 8.72287 12.3372 8.70312 12.3615 8.70312H14.984C15.0083 8.70312 15.0282 8.72286 15.0282 8.74725C15.0282 8.77165 15.0083 8.79138 14.984 8.79138Z'
        fill='white'
      />
      <path
        d='M14.984 9.26015H12.3615C12.3372 9.26015 12.3174 9.2404 12.3174 9.216C12.3174 9.19161 12.3372 9.17188 12.3615 9.17188H14.984C15.0083 9.17188 15.0282 9.19161 15.0282 9.216C15.0282 9.2404 15.0083 9.26015 14.984 9.26015Z'
        fill='white'
      />
      <path
        d='M20.8323 4.26562H16.4556L16.4556 7.2591H20.8323L20.8323 4.26562Z'
        fill='#FF5612'
      />
      <path
        d='M20.4033 4.64844H16.8838L16.8838 6.87457H20.4033L20.4033 4.64844Z'
        fill='#FFCCA8'
      />
      <path
        d='M19.9552 5.33829H17.3327C17.3084 5.33829 17.2886 5.31854 17.2886 5.29415C17.2886 5.26975 17.3084 5.25 17.3327 5.25H19.9552C19.9795 5.25 19.9993 5.26975 19.9993 5.29415C19.9993 5.31854 19.9795 5.33829 19.9552 5.33829Z'
        fill='white'
      />
      <path
        d='M19.9552 5.80702H17.3327C17.3084 5.80702 17.2886 5.78729 17.2886 5.7629C17.2886 5.7385 17.3084 5.71875 17.3327 5.71875H19.9552C19.9795 5.71875 19.9993 5.7385 19.9993 5.7629C19.9993 5.78729 19.9795 5.80702 19.9552 5.80702Z'
        fill='white'
      />
      <path
        d='M19.9552 6.27576H17.3327C17.3084 6.27576 17.2886 6.25603 17.2886 6.23163C17.2886 6.20723 17.3084 6.1875 17.3327 6.1875H19.9552C19.9795 6.1875 19.9993 6.20723 19.9993 6.23163C19.9993 6.25603 19.9795 6.27576 19.9552 6.27576Z'
        fill='white'
      />
      <path
        d='M20.8323 7.25781H16.4556L16.4556 10.2513H20.8323L20.8323 7.25781Z'
        fill='#FCE99A'
      />
      <path
        d='M20.4033 7.64062H16.8838L16.8838 9.86674H20.4033L20.4033 7.64062Z'
        fill='#FFF8D2'
      />
      <path
        d='M19.9552 8.33044H17.3327C17.3084 8.33044 17.2886 8.31071 17.2886 8.28632C17.2886 8.26192 17.3084 8.24219 17.3327 8.24219H19.9552C19.9795 8.24219 19.9993 8.26192 19.9993 8.28632C19.9993 8.31071 19.9795 8.33044 19.9552 8.33044Z'
        fill='white'
      />
      <path
        d='M19.9552 8.79138H17.3327C17.3084 8.79138 17.2886 8.77163 17.2886 8.74725C17.2886 8.72287 17.3084 8.70312 17.3327 8.70312H19.9552C19.9795 8.70312 19.9993 8.72286 19.9993 8.74725C19.9993 8.77165 19.9795 8.79138 19.9552 8.79138Z'
        fill='white'
      />
      <path
        d='M19.9552 9.26015H17.3327C17.3084 9.26015 17.2886 9.2404 17.2886 9.216C17.2886 9.19161 17.3084 9.17188 17.3327 9.17188H19.9552C19.9795 9.17188 19.9993 9.19161 19.9993 9.216C19.9993 9.2404 19.9795 9.26015 19.9552 9.26015Z'
        fill='white'
      />
      <path
        d='M28.5119 16.6025C28.5119 16.6025 27.7759 16.9375 27.6063 16.6608C27.4367 16.3842 27.0746 16.0965 26.9562 16.0118C26.7977 15.8985 26.427 15.368 26.2975 15.5681C26.168 15.7682 26.8696 16.4714 26.9899 16.6481C27.1102 16.8248 26.203 16.7199 26.029 16.8363C25.855 16.9527 25.8465 18.5222 26.4736 18.5193C27.1007 18.5165 27.7487 18.0814 27.8601 18.1037C27.9716 18.1261 28.6918 17.9621 28.6918 17.9621L28.5119 16.6025V16.6025Z'
        fill='#FAC1A9'
      />
      <path
        d='M26.1735 16.8047C26.1735 16.8047 24.2603 16.9466 24.1456 17.0677C24.0309 17.1889 24.0495 17.2971 24.2293 17.2916C24.4091 17.2861 26.0841 17.2106 26.0841 17.2106C26.0841 17.2106 23.8654 17.7768 23.7495 17.8536C23.6817 17.8986 23.7058 18.1095 23.8027 18.1159C23.8997 18.1223 26.1357 17.6938 26.1357 17.6938C26.1357 17.6938 24.0651 18.2265 23.988 18.3218C23.9206 18.4053 23.9891 18.5954 24.1457 18.567C24.3024 18.5386 26.2563 18.159 26.2563 18.159C26.2563 18.159 24.7773 18.6468 24.7597 18.7698C24.7488 18.8451 24.7615 19.028 25.1388 18.8894C25.5161 18.751 26.4436 18.5234 26.4436 18.5234L26.1735 16.8047Z'
        fill='#FAC1A9'
      />
      <path
        d='M46.2277 48.8984C46.2277 48.8984 46.7377 49.2625 47.0203 49.5175C47.3028 49.7725 47.6873 50.0499 47.9227 50.7006C48.1609 51.3592 47.7855 51.8323 47.1478 51.8713C46.5102 51.9103 45.5329 51.4288 45.4377 50.845C45.3434 50.267 44.5943 50.3351 44.4967 49.9237C44.3991 49.5125 44.5296 49.0064 44.5296 49.0064L46.2277 48.8985L46.2277 48.8984Z'
        fill='#C2C4CF'
      />
      <path
        d='M46.1427 48.4219L46.2277 48.8999C46.2277 48.8999 45.9651 49.3859 44.5297 49.0079L44.6036 48.5367L46.1427 48.4219Z'
        fill='#FAC1A9'
      />
      <path
        d='M44.5293 49.0098C44.5293 49.0098 44.8526 49.0523 45.0829 49.0885C45.3133 49.1247 45.7694 48.8304 46.2274 48.9019L46.0865 49.4833C46.0865 49.4833 44.5614 49.1976 44.5293 49.0098Z'
        fill='#C2C4CF'
      />
      <path
        d='M37.067 48.8984C37.067 48.8984 36.557 49.2625 36.2744 49.5175C35.9918 49.7725 35.6074 50.0499 35.372 50.7006C35.1338 51.3592 35.5092 51.8323 36.1468 51.8713C36.7845 51.9103 37.7617 51.4288 37.857 50.845C37.9512 50.267 38.7003 50.3351 38.7979 49.9237C38.8956 49.5125 38.765 49.0064 38.765 49.0064L37.067 48.8985L37.067 48.8984Z'
        fill='#C2C4CF'
      />
      <path
        d='M37.1521 48.4219L37.0671 48.8999C37.0671 48.8999 37.3297 49.3859 38.7652 49.0079L38.6912 48.5367L37.1521 48.4219Z'
        fill='#FAC1A9'
      />
      <path
        d='M36.5523 22.4188C36.5523 22.4188 41.4997 21.4432 44.0649 22.3648C44.172 22.4033 44.275 22.4452 44.3733 22.4904C44.3733 22.4904 44.3794 22.5341 44.3905 22.6161C44.4163 22.8057 44.47 23.2009 44.5414 23.7389C44.5535 23.8293 44.5659 23.9238 44.579 24.0221C44.9442 26.7862 45.4898 30.8036 45.5942 32.7639C45.7312 35.3359 45.8739 35.7021 45.8741 36.1857C45.8745 37.4892 46.3323 48.4666 46.3323 48.4666C46.3323 48.4666 45.5558 48.8833 44.3581 48.4666C44.3581 48.4666 42.9449 37.5775 42.6998 36.7719C42.4546 35.9663 40.7184 28.6241 40.4113 28.5891C40.1043 28.5541 39.2529 36.3483 39.1882 37.408C39.1235 38.4673 39.1848 48.2973 38.8345 48.4724C38.4842 48.6475 37.0612 48.6658 36.9562 48.3155C36.9562 48.3155 36.5402 38.3227 36.5402 37.2721C36.5402 36.2214 36.2011 28.0349 36.2309 27.6842C36.2309 27.6842 36.1343 25.1141 36.5523 22.4188L36.5523 22.4188Z'
        fill='#242C46'
      />
      <path
        d='M38.8595 8.29153C38.8595 8.29153 34.6585 9.18345 34.3083 10.3509C33.958 11.5183 33.3355 13.4393 32.572 16.4732C32.4572 16.9293 28.1203 16.3177 28.1203 16.3177C28.1203 16.3177 27.7592 18.1673 27.7496 18.2267C27.7235 18.3881 33.608 18.6866 34.0326 18.5789C34.6454 18.4234 35.678 14.3202 35.678 14.3202C35.678 14.3202 36.2343 20.5185 36.2343 21.4758C36.2343 22.4331 36.171 24.3718 36.171 24.3718C36.171 24.3718 37.7276 24.9681 40.7504 24.8105C40.7504 24.8105 45.5613 24.6452 44.7402 23.179C44.1193 22.0702 44.4998 14.6112 44.5932 14.5645C44.6866 14.5178 46.3638 16.6185 46.2003 17.0229C46.0369 17.4273 41.6964 18.8779 41.6964 18.8779C41.6964 18.8779 41.5695 19.3453 42.2438 20.4043C42.2438 20.4043 48.7271 18.5098 48.7505 18.1129C48.7738 17.7159 46.0539 10.0072 45.1656 9.6037C43.8867 9.02274 40.5425 8.10938 40.5425 8.10938L38.8595 8.29153Z'
        fill='#FF5C5C'
      />
      <path
        d='M38.7654 49.0098C38.7654 49.0098 38.4422 49.0523 38.2118 49.0885C37.9815 49.1247 37.5254 48.8304 37.0674 48.9019L37.2083 49.4833C37.2083 49.4833 38.7334 49.1976 38.7654 49.0098Z'
        fill='#C2C4CF'
      />
      <path
        d='M41.8706 23.2445L46.8033 21.8125L44.6467 14.3844L39.7141 15.8164L41.8706 23.2445Z'
        fill='white'
      />
      <path
        d='M41.7203 22.7579L47.6138 21.0469L45.0372 12.1718L39.1437 13.8828L41.7203 22.7579Z'
        fill='white'
      />
      <path
        d='M40.3489 18.6675C40.3489 18.6675 39.8804 18.6545 39.7368 18.6338C39.5933 18.6131 39.6881 18.9182 39.8547 18.9758C40.0212 19.0334 40.3489 18.6675 40.3489 18.6675Z'
        fill='#E6A180'
      />
      <path
        d='M40.0751 20.8994C40.0751 20.8994 40.2796 20.9491 40.3797 20.9271C40.3797 20.9271 40.5587 20.8733 40.6882 20.8427C40.7294 20.8331 40.7654 20.8257 40.7892 20.8234C40.8886 20.8134 41.1097 20.8214 41.3418 20.7305C41.5736 20.6399 42.3601 20.2366 42.3601 20.2366L42.1352 19.5053L41.9657 18.926C41.9657 18.926 40.6364 18.5723 40.4106 18.6317C40.3885 18.6377 40.367 18.6444 40.3472 18.6522C40.161 18.7212 40.0513 18.8508 39.9577 18.898C39.9234 18.9157 39.5942 19.1134 39.5771 19.2269C39.553 19.3843 39.6003 19.5032 39.6814 19.5761C39.6814 19.5761 39.6479 19.8865 39.763 20.0624C39.763 20.0624 39.723 20.3477 39.9284 20.5257C39.9284 20.5257 39.9202 20.8196 40.0751 20.8993L40.0751 20.8994Z'
        fill='#FAC1A9'
      />
      <path
        d='M41.6963 18.8336C41.6963 18.8336 41.6851 19.8132 42.2894 20.5449C42.2894 20.5449 47.0046 18.9203 47.5718 18.6973C48.1388 18.4743 45.5113 11.4922 45.5113 11.4922L43.5781 12.1503L44.6167 14.1143C44.6167 14.1143 45.1308 15.2146 46.2003 17.0244C46.2003 17.0244 45.5421 17.6037 41.6963 18.8336Z'
        fill='#FF5C5C'
      />
      <path
        d='M41.9339 8.51145C41.9339 8.51145 41.9808 10.3804 40.0559 10.3356C38.0635 10.2893 38.4857 8.38189 38.4857 8.38189C38.4857 8.38189 39.9939 7.72535 41.9339 8.51145Z'
        fill='white'
      />
      <path
        d='M38.9275 6.82797C38.9275 6.82797 39.1006 7.77649 38.8029 8.42443C38.8029 8.42443 38.4998 9.93428 40.0455 10.002C41.5912 10.0697 41.5745 8.37323 41.5745 8.37323C41.5745 8.37323 41.257 8.18825 41.5038 6.83728C41.7506 5.4862 38.9275 6.82797 38.9275 6.82797Z'
        fill='#FAC1A9'
      />
      <path
        d='M41.4453 8.11639C41.4453 8.46972 40.7945 9.14165 40.2002 9.14165C39.6058 9.14165 39.3369 7.84074 39.3369 7.48739C39.3369 7.13404 39.6058 7.86209 40.2002 7.86209C40.7945 7.86209 41.4453 7.76304 41.4453 8.11639Z'
        fill='#DCA893'
      />
      <path
        d='M42.3547 3.07812L42.1212 6.1957L41.7051 3.34131L42.3547 3.07812Z'
        fill='#2B2419'
      />
      <path
        d='M41.7408 6.08972C41.7408 6.08972 42.0773 5.14117 42.634 5.35048C43.1907 5.55979 42.6159 7.13512 41.7605 6.82634L41.7408 6.0897V6.08972Z'
        fill='#FAC1A9'
      />
      <path
        d='M42.1398 5.51583C42.1856 7.22824 41.564 8.58427 40.5201 8.61854C39.4762 8.65273 38.4051 7.35214 38.3593 5.6397C38.3135 3.92728 39.1226 2.51136 40.1666 2.47717C40.871 2.45408 41.6526 3.09606 42.0028 4.02275C42.1716 4.46932 42.1248 4.95896 42.1398 5.51581L42.1398 5.51583Z'
        fill='#FAC1A9'
      />
      <path
        d='M38.5337 6.73329C37.9545 6.89933 37.5457 6.2407 37.5035 5.73205C37.4826 5.47555 37.5549 5.2578 37.7447 5.19968C38.1457 5.07977 38.403 5.52707 38.5203 5.80068C38.5701 5.9154 38.5337 6.73329 38.5337 6.73329Z'
        fill='#FAC1A9'
      />
      <path
        d='M38.921 3.24229C38.921 3.24229 41.0188 4.70229 42.1459 3.54178C43.273 2.38127 42.0833 1.78229 41.6136 1.85717C41.6136 1.85717 41.7702 1.22076 41.144 1.14589C40.5178 1.07102 40.6431 1.81974 39.7038 1.81974C38.7645 1.81974 38.2949 1.89461 38.3888 2.8305C38.3888 2.8305 37.9191 2.49359 37.7626 3.12999C37.6061 3.7664 38.2009 5.86282 38.2009 5.86282L38.2636 6.19974H38.4201L38.4201 4.4028C38.4201 4.4028 39.015 4.62742 38.921 3.24229Z'
        fill='#2B2419'
      />
      <path
        d='M1.24463 20.5191L1.24463 12.5859H3.48485L3.68987 20.5191H1.24463Z'
        fill='#FFA870'
      />
      <path
        d='M1.50293 17.1484H3.19435L3.29687 20.1041H1.50293L1.50293 17.1484Z'
        fill='#FF7837'
      />
      <path
        d='M5.62354 30.9566L5.62354 23.0234H7.86377L8.06878 30.9566H5.62354Z'
        fill='#FCE99A'
      />
      <path
        d='M5.88184 27.5859H7.57322L7.67576 30.5416H5.88184L5.88184 27.5859Z'
        fill='#FFF8D2'
      />
      <path
        d='M3.68958 20.5148L3.5083 13.5H5.81951L5.72837 20.5148H3.68958Z'
        fill='#FCE99A'
      />
      <path
        d='M5.36386 17.9297H3.92871L3.92871 20.0311H5.36386L5.36386 17.9297Z'
        fill='#FFF8D2'
      />
      <path
        d='M5.72852 20.5213L5.81965 12.8672H7.96098L8.05208 20.5213H5.72852Z'
        fill='#FFA870'
      />
      <path
        d='M6.09269 17.6719H7.61894L7.61894 18.1645H6.07275L6.09269 17.6719Z'
        fill='white'
      />
      <path
        d='M6.09269 18.3125H7.61894L7.61894 18.8051H6.07275L6.09269 18.3125Z'
        fill='white'
      />
      <path
        d='M6.09269 18.9531H7.61894L7.61894 19.4457H6.07275L6.09269 18.9531Z'
        fill='white'
      />
      <path
        d='M10.3591 30.9041L10.2679 23.25L7.87207 23.3351L8.0355 30.9041H10.3591Z'
        fill='#FFA870'
      />
      <path
        d='M9.89832 24.0391H8.37207L8.37207 24.5317H9.91826L9.89832 24.0391Z'
        fill='white'
      />
      <path
        d='M9.89832 24.6875H8.37207L8.37207 25.1801H9.91826L9.89832 24.6875Z'
        fill='white'
      />
      <path
        d='M9.89832 25.3203H8.37207L8.37207 25.8129H9.91826L9.89832 25.3203Z'
        fill='white'
      />
      <path
        d='M8.05214 20.525L7.98291 14.7102L10.165 14.625L10.165 20.525H8.05214Z'
        fill='#FCE99A'
      />
      <path
        d='M8.26855 15.2424L8.26855 17.7283H9.82326L9.82326 15.1484L8.26855 15.2424Z'
        fill='#FFF8D2'
      />
      <path
        d='M5.63697 24.9219H1.26025L1.26025 27.9154H5.63697L5.63697 24.9219Z'
        fill='#FFA870'
      />
      <path
        d='M5.20797 25.3047H1.68848L1.68848 27.5308H5.20797L5.20797 25.3047Z'
        fill='#FF7837'
      />
      <path
        d='M4.75987 25.9945H2.13741C2.1131 25.9945 2.09326 25.9748 2.09326 25.9504C2.09326 25.926 2.1131 25.9062 2.13741 25.9062H4.75987C4.7842 25.9062 4.80402 25.926 4.80402 25.9504C4.80402 25.9748 4.7842 25.9945 4.75987 25.9945Z'
        fill='white'
      />
      <path
        d='M4.75982 26.4633H2.13736C2.11305 26.4633 2.09322 26.4435 2.09322 26.4191C2.09322 26.3947 2.11305 26.375 2.13736 26.375H4.75982C4.78415 26.375 4.80397 26.3947 4.80397 26.4191C4.80397 26.4435 4.78415 26.4633 4.75982 26.4633Z'
        fill='white'
      />
      <path
        d='M4.75987 26.932H2.13741C2.1131 26.932 2.09326 26.9123 2.09326 26.8879C2.09326 26.8635 2.1131 26.8438 2.13741 26.8438H4.75987C4.7842 26.8438 4.80402 26.8635 4.80402 26.8879C4.80402 26.9123 4.7842 26.932 4.75987 26.932Z'
        fill='white'
      />
      <path
        d='M5.63697 27.9141H1.26025L1.26025 30.9076H5.63697L5.63697 27.9141Z'
        fill='#FF7837'
      />
      <path
        d='M5.20797 28.2891H1.68848L1.68848 30.5152H5.20797L5.20797 28.2891Z'
        fill='#FFA870'
      />
      <path
        d='M4.75987 28.9867H2.13741C2.1131 28.9867 2.09326 28.967 2.09326 28.9426C2.09326 28.9182 2.1131 28.8984 2.13741 28.8984H4.75987C4.7842 28.8984 4.80402 28.9182 4.80402 28.9426C4.80402 28.9669 4.7842 28.9867 4.75987 28.9867Z'
        fill='white'
      />
      <path
        d='M4.75987 29.4476H2.13741C2.1131 29.4476 2.09326 29.4279 2.09326 29.4035C2.09326 29.3791 2.1131 29.3594 2.13741 29.3594H4.75987C4.7842 29.3594 4.80402 29.3791 4.80402 29.4035C4.80402 29.4279 4.7842 29.4476 4.75987 29.4476Z'
        fill='white'
      />
      <path
        d='M4.75987 29.9164H2.13741C2.1131 29.9164 2.09326 29.8966 2.09326 29.8723C2.09326 29.8479 2.1131 29.8281 2.13741 29.8281H4.75987C4.7842 29.8281 4.80402 29.8479 4.80402 29.8723C4.80402 29.8966 4.7842 29.9164 4.75987 29.9164Z'
        fill='white'
      />
    </svg>
  );
};

export default ForPublishers;
